import { styled } from "styled-components";
import { Icons } from "../../icons";
import { FlexColumnCenter, FlexRowCenter } from "../Styles";
import ColorPickerProps from "./ColorPicker";
import Hexagon from "./Hexagon";
import { colors, convertRGBToHEX, hex_to_rgb } from "./utils";

export default function ColorPicker({
  color,
  setColor,
}: ColorPickerProps.IProps) {
  return (
    <FlexColumnCenter $gapInPx={16}>
      <FlexColumnCenter $gapInPx={0}>
        {colors.map((rowWiseColor, index) => (
          <HexagonContainer key={index} $isFirstRow={index === 0}>
            {rowWiseColor.map((fill, i) => (
              <Hexagon
                key={`${index}-${i}`}
                color={fill}
                setColor={setColor}
                showBorder={color === fill}
              />
            ))}
          </HexagonContainer>
        ))}
      </FlexColumnCenter>
      <FlexRowCenter $gapInPx={16}>
        <FlexColumnCenter $gapInPx={0}>
          {Array.from({ length: 2 }, (_, index) => (
            <HexagonContainer key={index} $isFirstRow={index === 0}>
              {Array.from({ length: 8 - index }, (_, i) => {
                const fillColor = convertRGBToHEX({
                  ...hex_to_rgb(color),
                  a: (i + (index ? 10 : 2)) * 5 + 5,
                });

                return (
                  <Hexagon
                    key={`opacity-${index}-${i}`}
                    color={fillColor}
                    setColor={setColor}
                    showBorder={color === fillColor}
                  />
                );
              })}
            </HexagonContainer>
          ))}
        </FlexColumnCenter>
        <Icons.HexagonIcon color={color} />
      </FlexRowCenter>
    </FlexColumnCenter>
  );
}

const HexagonContainer = styled.div<{ $isFirstRow: boolean }>`
  display: flex;
  margin-top: ${({ $isFirstRow }) => ($isFirstRow ? " 0px" : "-4px")};
`;
